import { render, staticRenderFns } from "./exportsSetting.vue?vue&type=template&id=613ad915&scoped=true"
import script from "./exportsSetting.vue?vue&type=script&lang=js"
export * from "./exportsSetting.vue?vue&type=script&lang=js"
import style0 from "./exportsSetting.vue?vue&type=style&index=0&id=613ad915&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613ad915",
  null
  
)

export default component.exports